<button type="button" class="button is-link" style="margin-left:10px;" [routerLink]="RouterLink">
    <span class="icon-text">
        <span> <ng-content #text></ng-content> </span>
        <span class="icon">
          <i class="fa fa-{{Icon}}"></i>
        </span>
      </span>
</button>